const MessageType = {
    newOffer: 1,
    offerAccepted: 2,
    counterOffer: 3,
    newHoldRequest: 4,
    holdRequestAccepted: 5,
    holdRequestDenied: 6,
    counterOfferAccepted: 7,
    counterOfferDenied: 8,
    newEnquiry: 9,
    newMessage: 10,
    newDeal: 11,
    offerDenied: 12,
    offerExpired: 14,
    holdRequestExpired: 15,
};

export default MessageType
